'use strict';

var Reflux                = require('reflux'),
    React                 = require('react'),
    _                     = require('underscore'),
    classnames            = require('classnames'),
    PageMixin             = require('js/shared/utils/page-mixin.js'),
    ApplicationActions    = require('js/shared/actions/application-actions.js'),
    UniversityCreationModal = require('js/screens/form/universitycreation-modal.jsx'),
    UniversitySearchStore = require('js/shared/stores/universitysearch-store.js');

var STORES = [UniversitySearchStore];

var UniDropdownInput = React.createClass({

  mixins: [new PageMixin(STORES),
           Reflux.listenTo(UniversitySearchStore, '_universityStoreUpdated')].concat(_.map(STORES, function (store) {
    return Reflux.listenTo(store, '_updateState');
  })),

  propTypes: {
    title: React.PropTypes.string.isRequired,
    subtitle: React.PropTypes.string,
    fieldName: React.PropTypes.string.isRequired,

    value: React.PropTypes.number,

    autoFocus: React.PropTypes.bool,

    nextCallback: React.PropTypes.func,

    onReview: React.PropTypes.bool,
    hasError: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      value: -1,
      autoFocus: false,
      subtitle: null
    };
  },

  getInitialState: function() {
    return {
      value: this.props.value,
      textInput: "",
      focusedIndex: 0,
      dropdownOpen: false,
      showError: false,
      modalActive: false,
    };
  },

  inputKeyDownMap: {
    38: '_focusPrevious',
    40: '_focusNext',
    13: '_selectOnEnter'
  },

  optionKeyDownMap: {
    38: '_focusPrevious',
    40: '_focusNext',
    13: '_selectOption'
  },

  _selectOnEnter: function() {
    if (this.state.value !== -1) {
      this.props.nextCallback();
    }

    if (this._getCurrentChildList() !== undefined && this._getCurrentChildList().length === 0) return;
    this._updateSelectedUniversity(this._getCurrentChildList()[0].id);
    this.setState({
      dropdownOpen: false
    });
  },

  _handleKeyDown: function(event) {
    if(!this.state.showError) {
      this.setState({
        showError: true
      });
    }

    var handlerName = this.inputKeyDownMap[event.keyCode];
    if (!handlerName)
      return;
    event.preventDefault();
    this[handlerName].call(this);
  },

  _handleChange: function(evt) {
    var newTextInput = evt.target.value;

    if(!this._isValidResult(newTextInput)) {
      this.setState({
        value: -1
      });

      this._clearSelectedUniversity();
    }

    if (this.state.universityResults[newTextInput] === undefined && newTextInput !== "") {
      ApplicationActions.searchUniversities(newTextInput);
    }

    if (newTextInput !== "") {
      this.setState({
        dropdownOpen: true
      });
    }

    this.setState({
      textInput: newTextInput,
      focusedIndex: null
    });
  },

  _onClickCreateUniStartButton: function() {
    this.setState({
      modalActive: true
    });
  },

  _updateSelectedUniversity: function(id, evt) {
    ApplicationActions.updateField(this.props.fieldName, id);
    this.setState({
      value: id,
      textInput: this.state.universities[id].name
    });

    // fixes error when this is called manually. need to refactor so this isn't the case
    if (evt !== undefined) {
      evt.preventDefault();
    }
  },

  _clearSelectedUniversity: function() {
    ApplicationActions.updateField(this.props.fieldName, null);
  },

  _getCurrentChildList: function() {
    var ret = this.state.universityResults[this.state.textInput];
    return (ret === undefined) ? [] : ret;
  },

  focusOption: function() {
    var index = this.state.focusedIndex;
    this.refs.list.getDOMNode().childNodes[index].focus();
  },

  _selectInput: function() {
    this.refs.input.getDOMNode().select();
  },

  _handleOptionKeyDown: function(child_idx, event) {
    var handlerName = this.optionKeyDownMap[event.keyCode];
    if (!handlerName) {
      // if the user starts typing again while focused on an option, move focus
      // to the input, select so it wipes out any existing value
      this._selectInput();
      return;
    }

    event.preventDefault();
    if (handlerName === "_selectOption" && child_idx === this._getCurrentChildList().length) {
      this._onClickCreateUniStartButton();
    }
    else {
      this[handlerName].call(this, child_idx);
    }
  },

  _focusPrevious: function(child_idx) {
    if (this.state.textInput === "") return;
    var last = this._getCurrentChildList().length;
    var index = this.state.focusedIndex == null ?
      last : this.state.focusedIndex - 1;
    this._focusOptionAtIndex(index);
  },

  _focusNext: function() {
    if (this.state.textInput === "") return;
    var index = this.state.focusedIndex == null ?
      0 : this.state.focusedIndex + 1;
    this._focusOptionAtIndex(index);
  },

  _selectOption: function(child_idx) {
    if (child_idx === this._getCurrentChildList()) {
      this._onClickCreateUniStartButton();
      return;
    }

    this._updateSelectedUniversity(this._getCurrentChildList()[child_idx].id);
    this._selectInput();
    this.setState({
      dropdownOpen: false
    });
  },

  _focusOptionAtIndex: function(index) {
    var length = this._getCurrentChildList().length;
    if (index === -1)
      index = length;
    else if (index === length + 1)
      index = 0;
    this.setState({
      focusedIndex: index
    }, this.focusOption);
  },

  _textInputFocus: function() {
    if (this.state.dropdownOpen === false) {
      this.setState({
        focusedIndex: 0
      });
    }
    this.setState({
      dropdownOpen: true
    });
  },

  _textInputBlur: function() {
    this.setState({
      dropdownOpen: false
    });
  },

  _listItemFocus: function() {
    this.setState({
      dropdownOpen: true
    });
  },

  _listItemBlur: function() {
    this.setState({
      dropdownOpen: false
    });
  },

  _handleMouseDown: function(evt) {
    // blocks blur on if we click elements we have blur attached to!
    // prevents the dropdown closing when you click the dropdown itself
    evt.preventDefault();
  },

  _renderOption: function(element, i) {
    var uniDropdownItemClassNames = classnames({
      "QuestionInput-dropdown-item": true,
      "QuestionInput-dropdown-item--focus": this.state.focusedIndex === i
    });

    return (
      <div
        className={uniDropdownItemClassNames}
        key={element.id}
        value={element.id}
        tabIndex={-1}
        onFocus={this._listItemFocus}
        onBlur={this._listItemBlur}
        onKeyDown={this._handleOptionKeyDown.bind(null, i)}
        onMouseDown={this._handleMouseDown}
        onClick={this._updateSelectedUniversity.bind(null, element.id)}
        onTouchEnd={this._updateSelectedUniversity.bind(null, element.id)}
        >
        {element.name} ({element.country_code})
      </div>
    );
  },

  _renderOptions: function(elements) {
    var $this = this;
    var options =  _.chain(elements)
                    .filter(elem => elem.id !== this.state.value)
                    .map((elem, i) => this._renderOption(elem, i))
                    .value();

    var uniDropdownAddClassNames = classnames({
      "QuestionInput-dropdown-item": true,
      "QuestionInput-dropdown-item--focus": this.state.focusedIndex === this._getCurrentChildList().length
    });

    options.push(
      <div
        className={uniDropdownAddClassNames}
        key="hackerapicreatenewuni"
        tabIndex={-1}
        onFocus={this._listItemFocus}
        onBlur={this._listItemBlur}
        onKeyDown={this._handleOptionKeyDown.bind(null, this._getCurrentChildList().length)}
        onMouseDown={this._handleMouseDown}
        onTouchEnd={this._onClickCreateUniStartButton}
        onClick={this._onClickCreateUniStartButton}>
        + Add a new school
      </div>
    );
    return options;
  },

  _isValidResult: function(str) {
    return _.some(
      this.state.universityResults[str],
      result => result.name.toLowerCase() === str.toLowerCase()
    );
  },

  _universityStoreUpdated: function() {
    this.setState({},
      function() {
      if (this._isValidResult()) {
      var match = _.filter(this.state.universityResults[this.state.textInput],
                     result => result.name.toLowerCase() === this.state.textInput.toLowerCase())[0];
      this.setState({
        value: match.id,
        textInput: match.name
      });
    }}.bind(this));
  },

  _modalHandleDismiss: function() {
    this.setState({
      modalActive: false,
      dropdownOpen: true
    });
    this.refs.input.getDOMNode().focus();
  },

  _modalHandleCreate: function(schoolName, country, institutionType) {
    // note: this implicitly moves to the next question!
    this.setState({
      modalActive: false
    });
    ApplicationActions.createNewSchool(schoolName, country, institutionType);
  },

  _mouseClickFocus: function() {
    this.setState({
      dropdownOpen: true
    });
    this.refs.input.getDOMNode().focus();
  },

  render: function() {
    var listOfOptions = null;

    if (this._getCurrentChildList() !== undefined) {
      listOfOptions = this._renderOptions(this._getCurrentChildList());
    }
    else if (this.state.textInput !== "" && this.state.value === -1) {
      listOfOptions = <div className="QuestionInput-dropdown-item">Loading</div>;
    }

    var titleClasses = classnames({
      'QuestionInput-title': true,
      'QuestionInput-title--compact': this.props.onReview || this.props.subtitle === null,
      'QuestionInput-title--placeholder': this.state.value === -1 && this.state.textInput === ""  && !this.props.onReview && this.props.subtitle === null,
      'QuestionInput-title--review': this.props.onReview
    });

    var dropdownClasses = classnames({
      'QuestionInput-dropdown': true,
      'QuestionInput-dropdown--review': this.props.onReview,
      'QuestionInput-dropdown--placeholder': this.props.subtitle && !this.props.onReview,
      'QuestionInput-dropdown--hidden': !this.state.dropdownOpen || this.state.value !== -1
    });

    var subtitle = null;
    if(!this.props.onReview) {
      subtitle = <div className="QuestionInput-subtitle">
        {this.props.subtitle}
      </div>;
    }

    var dropdownList = null;
    var dropdownActive = listOfOptions !== null &&
                         listOfOptions.length > 0 &&
                         this.state.textInput !== "" &&
                         this.state.value === -1 &&
                         this.state.dropdownOpen;
    if (dropdownActive) {
      dropdownList = (
        <div
          ref="list"
          className={dropdownClasses}>
          {listOfOptions}
        </div>
      );
    }

    var textInput = this.state.textInput;
    if (this.state.value !== -1) {
      textInput = this.state.universities[this.state.value].name;
    }

    var error = null;
    if(this.state.showError && this.props.hasError) {
      error = (
        <div className="QuestionError active">
          This field cannot be blank. School must be from the list.
        </div>
      );
    }

    var createSchoolModal = null;
    if (this.state.modalActive) {
      createSchoolModal = <UniversityCreationModal
                            handleCreate={this._modalHandleCreate}
                            handleDismiss={this._modalHandleDismiss}
                            defaultSchoolName={this.state.textInput} />;
    }

    var inputClasses = classnames({
      'QuestionInput-textField': true,
      'QuestionInput-textField--review': this.props.onReview
    });

    return (
      <div style={{position: "relative"}}>
        {createSchoolModal}
        <div
          className={titleClasses}>
          {this.props.title}
        </div>
        {subtitle}

        <div>
          <input
            className={inputClasses}
            ref="input"
            type="text"
            value={textInput}
            autoFocus={this.props.autoFocus}
            tabIndex={0}
            onFocus={this._textInputFocus}
            onBlur={this._textInputBlur}
            onKeyDown={this._handleKeyDown}
            onChange={this._handleChange} />
        </div>
        <div style={{position: "relative"}}>
          {dropdownList}
        </div>
        {error}
      </div>
    );
  }
});

module.exports = UniDropdownInput;



/** WEBPACK FOOTER **
 ** ./js/screens/form/input/unidropdown.jsx
 **/